export enum Page {
  Home = 'home',
  Contact = 'contact',
  Company = 'company',
  Search = 'search',
  Login = 'login',
  NoAccess = 'no-access',
  Terms = 'terms',
  Settings = 'settings',
  Meeting = 'meeting',
  Email = 'email',
  GoogleSheets = 'googleSheets',
}

export enum CompanyTabName {
  Contacts = 'contacts',
  Overview = 'overview',
  Insights = 'insights',
}
